function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M215.9 38.5L169 0l-34.6 98.8H28.5V63.6H0l.1 219.9h71.1v-70.8h77.7v70.8H220v-92.1l9.8-18.5v-38h30.9l22.8-70.5-67.6-25.9zm-24.4 145.8V255h-14.4v-70.9H42.8V255H28.6V127.5h126.1l46.7 27.4v10.8l-9.9 18.6zm48.5-78h-38.7v15.6L164.2 100l18.3-52.3 18.9 15.7 46.8 17.9-8.2 25z"
})));